import { render, staticRenderFns } from "./CorporateCollaboration.vue?vue&type=template&id=0e92da2e&scoped=true"
import script from "./CorporateCollaboration.vue?vue&type=script&lang=js"
export * from "./CorporateCollaboration.vue?vue&type=script&lang=js"
import style0 from "./corporateCollaboration.css?vue&type=style&index=0&id=0e92da2e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e92da2e",
  null
  
)

export default component.exports